import React from 'react';
import { Modal, Button, Typography, Row, Col } from 'antd';
import { CheckCircleFilled, StarFilled } from '@ant-design/icons';

const { Title, Text } = Typography;

const UpgradeModal = ({ showUpgradeModal, setShowUpgradeModal, history }) => {


    const handleCancel = () => {
        setShowUpgradeModal(false); // Hide the modal
        history.push('/'); // Redirect to home
      };
    
      const handleUpgrade = () => {
        setShowUpgradeModal(false); // Hide the modal
        history.push('/subscription-User'); // Redirect to subscription page
      };

  return (
    <Modal
      title={
        <Title level={4} style={{ margin: 0 }}>
          <StarFilled style={{ color: '#FFD700', marginRight: 8 }} />
          Upgrade to Premium
        </Title>
      }
      visible={showUpgradeModal}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel} >
          Not Now
        </Button>,
        <Button
          key="upgrade"
          type="primary"
          style={{ backgroundColor: '#1890ff', borderColor: '#1890ff' }}
          onClick={handleUpgrade}
        >
          Upgrade Now
        </Button>,
      ]}
      centered
      width={600}
    >
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Text>
            Unlock exclusive features and enhance your experience with a Premium subscription.
          </Text>
        </Col>
        <Col span={24}>
          <div style={{ marginTop: 16 }}>
            <Title level={5}>Premium Benefits:</Title>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li>
                <CheckCircleFilled style={{ color: '#52c41a', marginRight: 8 }} />
                Access to all premium features
              </li>
              <li>
                <CheckCircleFilled style={{ color: '#52c41a', marginRight: 8 }} />
                Priority customer support
              </li>
              <li>
                <CheckCircleFilled style={{ color: '#52c41a', marginRight: 8 }} />
                Ad-free experience
              </li>
              <li>
                <CheckCircleFilled style={{ color: '#52c41a', marginRight: 8 }} />
                Exclusive content and updates
              </li>
            </ul>
          </div>
        </Col>
        <Col span={24}>
          <Text type="secondary" style={{ fontSize: 12 }}>
            Your subscription will automatically renew unless canceled 24 hours before the end of the
            current period.
          </Text>
        </Col>
      </Row>
    </Modal>
  );
};

export default UpgradeModal;